import { NgxSpinnerService } from 'ngx-spinner';
import { SecurityService } from './../../../services/security.service';
import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/models/models';
@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss']
})
export class PerfilComponent implements OnInit {


  user: User;
  mensagem;

  constructor(private securityService: SecurityService,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.user = this.securityService.currentUserValue;
  }


  resetarSenha() {
    this.spinner.show();
    this.securityService.resetarSenha(null).then(res => {
      this.mensagem = `Foi enviado um e-mail de pedido reset de senha para ${this.securityService.currentUserValue.email}`;
      this.spinner.hide();
    });
  }

}
